import React from 'react';

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UbicacionCompoent from "../components/UbicacionComponent";
import PageTransition from "../components/PageTansition";

const Explora = () => {

    const slideHero = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const slideBanner1 = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };
    const slideHeroDesk = {
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };
    const slideFooter = {
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <main className="page explorar">
            {/* <PageTransition /> */}

            {/* Vista telefono */}
            <section id="hero">
                <div className="slide">
                    <div className="items">
                        <Slider {...slideHero}>
                            <div className="item">
                                <img
                                    src={"/images/explora/hero_5_slide_1_celular.png"}
                                    alt="slide 1"
                                />
                            </div>

                            <div className="item">
                                <img
                                    src={"/images/explora/hero_5_slide_2_celular.png"}
                                    alt="slide 2"
                                />
                            </div>

                            <div className="item">
                                <img
                                    src={"/images/explora/hero_5_slide_3_celular.png"}
                                    alt="slide 2"
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
                <div className="contenido">
                    <div className="logo">
                        <img
                            src={"/images/explora/logo_celular.svg"}
                            alt="logo Edificio Almirante"
                        />
                    </div>
                    <p className="texto">CALIDAD EN <span>CADA DETALLE</span> Y TERMINACIÓN</p>
                </div>
            </section>

            {/* Vista tablet escritorio */}
            <section id="hero-slide">
                <div className="slide">
                    <Slider {...slideHeroDesk}>
                        <div className="item">
                            <img
                                src={"/images/explora/hero_4_slide_1_escritorio.png"}
                                alt="baño"
                            />
                        </div>
                        <div className="item">
                            <img
                                src={"/images/explora/hero_4_slide_2_escritorio.png"}
                                alt="baño"
                            />
                        </div>
                        <div className="item">
                            <img
                                src={"/images/explora/hero_4_slide_3_escritorio.png"}
                                alt="comedor"
                            />
                        </div>
                    </Slider>
                </div>
                <div className="arriba">
                    <p className="big">EN CADA DETALLE <span>Y TERMINACIÓN</span></p>
                    <p className="big-dos">LA CALIDAD DE <span>SUS MATERIALES</span> <span>Y DISEÑO EN SU</span> COMPLEMENTO</p>
                </div>

                <div className="lista-imagenes">
                    <div className="item">
                        <div className="tablet">
                            <img
                                src={"/images/explora/contenido_4_tablet.png"}
                                alt="imagen baño"
                            />
                        </div>
                    </div>
                    <div className="item">
                        <div className="tablet">
                            <img
                                src={"/images/explora/contenido_5_tablet.png"}
                                alt="imagen baño"
                            />
                        </div>
                    </div>
                    <div className="item">
                        <div className="tablet">
                            <img
                                src={"/images/explora/contenido_6_tablet.png"}
                                alt="imagen baño"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section id="banner-1">
                <div className="arriba">
                    <p className="big">DESCUBRE</p>
                    <p className="small">NUEVAS FORMAS DE CONVERTIR UNA <span>PROPIEDAD QUE SEA 100% RENTABLE</span></p>
                </div>

                <div className="slide-banner-1">
                    <Slider {...slideBanner1}>
                        <div className="item">
                            <div className="in">
                                <div className="imagen">
                                    <img
                                        src={"/images/explora/contenido_3_slide_1_celular.png"}
                                        alt="baño"
                                    />
                                </div>
                                <div className="contenido">
                                    <div className="titulo">
                                        <p className="titulo-in">Baños</p>
                                    </div>
                                    <p className="texto">Cada detalle ha sido cuidadosamente pensado para crear un espacio de relajación y funcionalidad.</p>
                                    <div className="puntos">
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="in">
                                <div className="imagen">
                                    <img
                                        src={"/images/explora/contenido_3_slide_2_celular.png"}
                                        alt="baño"
                                    />
                                </div>
                                <div className="contenido">
                                    <div className="titulo">
                                        <p className="titulo-in">Comedor</p>
                                    </div>
                                    <p className="texto">Disfruta de momentos inolvidables en nuestro comedor exquisitamente diseñado.</p>
                                    <div className="puntos">
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="in">
                                <div className="imagen">
                                    <img
                                        src={"/images/explora/contenido_3_slide_3_celular.png"}
                                        alt="baño"
                                    />
                                </div>
                                <div className="contenido">
                                    <div className="titulo">
                                        <p className="titulo-in">Habitación</p>
                                    </div>
                                    <p className="texto">Con detalles acogedores y una atmósfera relajante, este espacio te invita a descansar, recargar energías y despertar renovado cada día.</p>
                                    <div className="puntos">
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                        <div className="punto"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Slider>
                </div>
            </section>

            <section id="banner-seguridad">
                <div className="cabecera">
                    <p className="titulo-small">Tamaños y distribución</p>
                    <div className="in">
                        <p className="titulo-big">DESCUBRE</p>
                        <p className="texto">NUEVAS FORMAS DE INVERTIR EN UNA <span> PROPIEDAD QUE SEA 100% RENTABLE</span></p>
                    </div>
                </div>
                <div className="fondo">
                    <p className="titulo">SEGURIDAD <small>HALL ACCESO CONTROLADO</small></p>

                    <div className="franja">
                        <div className="icono">
                            <div className="phone">
                                <img
                                    src={"/images/explora/icono_7_celular.svg"}
                                    alt="icono seguridad"
                                />
                            </div>

                            <div className="tablet">
                                <img
                                    src={"/images/explora/icono_6_tablet.png"}
                                    alt="icono seguridad"

                                />
                            </div>
                            <div className="note">
                                <img
                                    src={"/images/explora/icono_huella_escritorio.svg"}
                                    alt="icono seguridad"
                                />
                            </div>
                            <p className="texto-icono">CHAPA</p>
                        </div>

                        <div className="contenido">
                            <p className="texto">HUELLA DACTILAR <strong>En todos los departamentos</strong></p>
                        </div>
                    </div>
                </div>
                <div className="iconos">
                    <div className="icono">
                        <div className="phone">
                            <img
                                src={"/images/explora/icono_8_celular.svg"}
                                alt="icono supermecados"
                            />
                        </div>
                        <div className="tablet">
                            <img
                                src={"/images/explora/icono_8_celular.svg"}
                                alt="icono supermecados"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/explora/icono_10_escritorio.png"}
                                alt="icono supermecados"
                            />
                        </div>
                        <p className="texto-icono">CONEXIÓN</p>
                        <p className="texto">Acceso rápido a importantes <span> vías y servicios.</span></p>
                    </div>
                    <div className="icono">
                        <div className="phone">
                            <img
                                src={"/images/explora/icono_9_celular.svg"}
                                alt="icono supermecados"
                            />
                        </div>
                        <div className="tablet">
                            <img
                                src={"/images/explora/icono_9_celular.svg"}
                                alt="icono supermecados"
                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/explora/icono_11_escritorio.png"}
                                alt="icono supermecados"
                            />
                        </div>
                        <p className="texto-icono">PLUSVALIA</p>
                        <p className="texto">Aprovecha la <span>oportunidad de asegurar</span> tu futuro financiero.</p>
                    </div>
                    <div className="icono">
                        <div className="phone">
                            <img
                                src={"/images/explora/icono_10_celular.svg"}
                                alt="icono supermecados"
                            />
                        </div>
                        <div className="tablet">
                            <img
                                src={"/images/explora/icono_10_celular.svg"}
                                alt="icono supermecados"

                            />
                        </div>
                        <div className="note">
                            <img
                                src={"/images/explora/icono_12_escritorio.png"}
                                alt="icono supermecados"
                            />
                        </div>
                        <p className="texto-icono">INVERSIÓN</p>
                        <p className="texto">Un proyecto que combina <span> rentabilidad y comodidad</span> en un solo lugar.</p>
                    </div>
                </div>
            </section>

            <section id="atributos">
                <div className="atributo">
                    <div className="tablet">
                        <img
                            src={"/images/explora/parallax_1_tablet.png"}
                            alt="baños"
                        />
                    </div>
                    <div className="note">
                        <img
                            src={"/images/explora/parallax_2_escritorio.png"}
                            alt="baños"
                        />
                    </div>
                    <div className="contenido">
                        <p className="titulo">Baños</p>
                        <p className="texto">Sumérgete en la elegancia y la comodidad de nuestro baño meticulosamente diseñado. Cada detalle ha sido cuidadosamente pensado para crear un espacio de relajación y funcionalidad, donde puedes comenzar y terminar tu día con estilo y confort.</p>
                        <div className="puntos">
                            <div className="punto"></div>
                            <div className="punto"></div>
                            <div className="punto"></div>
                        </div>
                    </div>
                </div>
                <div className="atributo">
                    <div className="contenido">
                        <p className="titulo">Comedor</p>
                        <p className="texto">Disfruta de momentos inolvidables en nuestro comedor exquisitamente diseñado.</p>
                        <div className="puntos">
                            <div className="punto"></div>
                            <div className="punto"></div>
                            <div className="punto"></div>
                        </div>
                    </div>
                    <div className="tablet">
                        <img
                            src={"/images/explora/parallax_2_tablet.png"}
                            alt="baños"
                        />
                    </div>
                    <div className="note">
                        <img
                            src={"/images/explora/parallax_3_escritorio.png"}
                            alt="baños"
                        />
                    </div>
                </div>
                <div className="atributo">
                    <div className="tablet">
                        <img
                            src={"/images/explora/parallax_3_tablet.png"}
                            alt="baños"
                        />
                    </div>
                    <div className="note">
                        <img
                            src={"/images/explora/parallax_4_escritorio.png"}
                            alt="baños"
                        />
                    </div>
                    <div className="contenido">
                        <p className="titulo">Habitación</p>
                        <p className="texto">Con detalles acogedores y una atmósfera relajante, este espacio te invita a descansar, recargar energías y despertar renovado cada día.</p>
                        <div className="puntos">
                            <div className="punto"></div>
                            <div className="punto"></div>
                            <div className="punto"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="slide">
                <Slider {...slideFooter}>
                    <div className="item item-1"></div>
                    <div className="item item-2"></div>
                    <div className="item item-3"></div>
                    <div className="item item-4"></div>
                </Slider>
            </section>
            <UbicacionCompoent />
        </main>
    )
}


export default Explora